import type { IConfigComponents } from '@yimoka/react';
import { components as reactComponents } from '@yimoka/react';

import { Trans } from '@/locales/i18n';

import { PageLoading } from './ui/page-loading';

const baseComponents = reactComponents as unknown as IConfigComponents;

const globalLoading: IConfigComponents['Loading'] = ({ loading = true, children }) => {
  if (!loading) return <>{children}</>;
  return <PageLoading fullScreen={false} />;
};

export const components: IConfigComponents = {
  ...baseComponents,
  ErrorContent: baseComponents.ErrorContent,
  Trans,
  Loading: globalLoading,
  Skeleton: globalLoading,
};
